
import { connect } from "react-redux";
import { logout } from "../../redux/actions/session_actions";
import { withRouter } from 'react-router-dom';
import { fetchAllUsers, updateUserNotificationRead, fetchIncomingNotifications} from '../../redux/actions/user_actions';
import PrimaryHeader from "./PrimaryHeader";

const mSTP = state => {
    return {
        currentUser: state.session.user,
        users: state.users,
        currentUserId: state.session.user._id,
        loggedIn: state.session.isAuthenticated,
        notifications: Object.values(state.notifications)
    };
};

const mDTP = dispatch => ({
    logout: (userId) => dispatch(logout(userId)),
    fetchIncomingNotifications: (currentUserId) => dispatch(fetchIncomingNotifications(currentUserId)),
    fetchAllUsers: (cancelToken) => dispatch(fetchAllUsers(cancelToken)),
    updateUserNotificationRead: (userId) => dispatch(updateUserNotificationRead(userId)),
});

export default withRouter(connect(mSTP, mDTP)(PrimaryHeader));
